// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityLayerId } from '../tbs/entity-layer-id.js';


export class EraseTileOption implements flatbuffers.IUnpackableObject<EraseTileOptionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EraseTileOption {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEraseTileOption(bb:flatbuffers.ByteBuffer, obj?:EraseTileOption):EraseTileOption {
  return (obj || new EraseTileOption()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEraseTileOption(bb:flatbuffers.ByteBuffer, obj?:EraseTileOption):EraseTileOption {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EraseTileOption()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

entityLayerIds(index: number):EntityLayerId|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : null;
}

entityLayerIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

entityLayerIdsArray():Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? new Uint8Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

static startEraseTileOption(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addEntityLayerIds(builder:flatbuffers.Builder, entityLayerIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, entityLayerIdsOffset, 0);
}

static createEntityLayerIdsVector(builder:flatbuffers.Builder, data:EntityLayerId[]):flatbuffers.Offset {
  builder.startVector(1, data.length, 1);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt8(data[i]!);
  }
  return builder.endVector();
}

static startEntityLayerIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(1, numElems, 1);
}

static endEraseTileOption(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEraseTileOption(builder:flatbuffers.Builder, entityLayerIdsOffset:flatbuffers.Offset):flatbuffers.Offset {
  EraseTileOption.startEraseTileOption(builder);
  EraseTileOption.addEntityLayerIds(builder, entityLayerIdsOffset);
  return EraseTileOption.endEraseTileOption(builder);
}

unpack(): EraseTileOptionT {
  return new EraseTileOptionT(
    this.bb!.createScalarList<EntityLayerId>(this.entityLayerIds.bind(this), this.entityLayerIdsLength())
  );
}


unpackTo(_o: EraseTileOptionT): void {
  _o.entityLayerIds = this.bb!.createScalarList<EntityLayerId>(this.entityLayerIds.bind(this), this.entityLayerIdsLength());
}
}

export class EraseTileOptionT implements flatbuffers.IGeneratedObject {
constructor(
  public entityLayerIds: (EntityLayerId)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const entityLayerIds = EraseTileOption.createEntityLayerIdsVector(builder, this.entityLayerIds);

  return EraseTileOption.createEraseTileOption(builder,
    entityLayerIds
  );
}
}
